import{a as e}from"./chunk-RAAYCPUM.js";function t(...r){return e(Object.entries,r)}export{t as a};
